const ICONS = {
	other: '\\e820',
	paintbrush: '\\e821',
	ferriswheel: '\\e822',
	beerstein: '\\e823',
	child: '\\e824',
	camera: '\\e825',
	bag: '\\e826',
	hands: '\\e827',
	clouds: '\\e828',
	music: '\\e829',
	dinosaur: '\\e82a',
	masks: '\\e82b',
	dumbbell: '\\e82c',
	tools: '\\e82d',
	sports: '\\e82e',
	crafts: '\\e854',
	tech: '\\e853',
};

const COLORS = {
	cyan: '#71ABBE',
	orange: '#E6B962',
	pink: '#E6A9A5',
	purple: '#A79EE6',
	beige: '#D6CEAF',
	blue: '#16647F',
	teal: '#90A99C',
	green: '#7B9164',
	dark: '#243C45',
	sienna: '#F29A5C',
	navy: '#235299',
	violet: '#7B3A99',
	aqua: '#6ECCB0',
	rose: '#CA8B9B',
};

var styleBlock = document.createElement( 'style' );
	styleBlock.type = 'text/css';

document.head.appendChild( styleBlock );

export default function( category ) {
	var slug = category.slug;
	var icon = ICONS[ category.icon ] || ICONS.other;
	var color = COLORS[ category.color ] || COLORS.dark;

	if ( icon ) {
		styleBlock.innerHTML += `
			.category-card[data-model="${slug}"]:before,
			.filter-item[data-model="${slug}"] .category-icon:before,
			.venue-icon[data-category="${slug}"]:before,
			.map-marker[data-category="${slug}"]:before {
				content: '${icon}';
			}
		`;
	}

	if ( color ) {
		styleBlock.innerHTML += `
			.category-card[data-model="${slug}"],
			.venue-icon[data-category="${slug}"] {
				background: ${color};
			}
		`;
	}
}
